export default { sha: 'c00c952a35b9c6fb17e6acddf6d34f728b969018', buildNumber: 'undefined' }
